import styled from '@benzinga/themetron';

interface DataBarProps {
  hue: number;
  parsedNumber: number;
  range: number;
}

export const getDataBar = ({ hue, parsedNumber, range }: DataBarProps) =>
  styled.div({
    alignItems: 'center',
    backgroundColor: `hsla(${hue}, 75%, 65%, 0.4)`,
    display: 'flex',
    height: '100%',
    paddingLeft: '5px',
    position: 'absolute',
    width: `${parsedNumber * (range === 0 ? 0 : 100 / range)}%`,
  });
